/**
 * Product Empty State Component
 * Displayed when a product is not enabled for the brand
 */

import React from 'react';
import { Button, Empty, Typography, Space } from 'antd';
import { RocketOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './ProductEmptyState.css';

const { Title, Paragraph } = Typography;

interface ProductEmptyStateProps {
  productCode: 'fashsnap' | 'fashplay' | 'fashmatch';
  productName: string;
  description: string;
  onEnable: () => void;
  canEnable: boolean;
  isEnabling?: boolean;
}

const PRODUCT_INFO: Record<string, { icon: React.ReactNode; shortDesc: string }> = {
  fashsnap: {
    icon: '📸',
    shortDesc: 'Müşterileriniz ürünlerinizi anında üzerlerinde görebilir',
  },
  fashplay: {
    icon: '🎬',
    shortDesc: 'İnteraktif video deneyimi ile ürünlerinizi öne çıkarın',
  },
  fashmatch: {
    icon: '✨',
    shortDesc: 'Akıllı kombin önerileri ile satışlarınızı artırın',
  },
};

const ProductEmptyState: React.FC<ProductEmptyStateProps> = ({
  productCode,
  productName,
  description,
  onEnable,
  canEnable,
  isEnabling = false,
}) => {
  const info = PRODUCT_INFO[productCode];

  const handleLearnMore = () => {
    window.open(`https://www.fashcortex.com/products/${productCode}`, '_blank');
  };

  return (
    <div className="product-empty-state">
      <Empty
        image={
          <div className="empty-icon">{info.icon}</div>
        }
        imageStyle={{
          height: 80,
        }}
        description={
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div>
              <Title level={5} style={{ marginBottom: 8, marginTop: 16 }}>
                {productName} Aktif Değil
              </Title>
              <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                {info.shortDesc}
              </Paragraph>
            </div>

            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 0 }}>
              {description}
            </Paragraph>

            <Space size="middle" style={{ justifyContent: 'center', width: '100%' }}>
              <Button
                icon={<InfoCircleOutlined />}
                onClick={handleLearnMore}
              >
                Ürün Detayları
              </Button>
              {canEnable && (
                <Button
                  type="primary"
                  icon={<RocketOutlined />}
                  onClick={onEnable}
                  loading={isEnabling}
                >
                  Aktif Et
                </Button>
              )}
            </Space>
          </Space>
        }
      />
    </div>
  );
};

export default ProductEmptyState;
